import {
  _loginSuccess,
  _studentDataResponse,
  candidateAssignedPrograms,
  _studentDashboardResponse,
  _switchWhiteLabelProp,
  _uploadedImageForShare,
  _base64ProfileImage,
  _uploadToStorage,
  _createNewFeed,
  _emLeadsData,
  _ownLead,
  _withdrawLead,
} from "../actions/types";

const initialState = {
  loginSuccessNormal: "",
  studentData: "",
  assignedPrograms: "",
  dashboardData: "",
  whiteLabelProp: "",
  uploadedImageData: "",
  convertedBase64Binary: "",
  uploadToStorageResponse: "",
  createNewFeedResponse: "",
  emLeadsData: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case _loginSuccess:
      return {
        ...state,
        loginSuccessNormal: action.payload,
      };
    case _studentDataResponse:
      return {
        ...state,
        studentData: action.payload,
      };
    case candidateAssignedPrograms:
      return {
        ...state,
        assignedPrograms: action.payload,
      };
    case _studentDashboardResponse:
      return {
        ...state,
        dashboardData: action.payload,
      };
    case _switchWhiteLabelProp:
      return {
        ...state,
        whiteLabelProp: action.payload,
      };
    case _uploadedImageForShare:
      return {
        ...state,
        uploadedImageData: action.payload,
      };

    case _base64ProfileImage:
      return {
        ...state,
        convertedBase64Binary: action.payload,
      };

    case _uploadToStorage:
      return {
        ...state,
        uploadToStorageResponse: action.payload,
      };
    case _createNewFeed:
      return {
        ...state,
        createNewFeedResponse: action.payload,
      };
    // case _emLeadsData:
    //   return {
    //     ...state,
    //     emLeadsData: action.payload,
    //   };
    // case _withdrawLead:
    //   var myLeads = { ...state.emLeadsData.myLeads.myLeads };
    //   delete myLeads[action.payload];
    //   var myLeads = {
    //     myLeads,
    //     myLeadsCount: state.emLeadsData.myLeads.myLeadsCount - 1,
    //   };
    //   debugger;
    //   return {
    //     ...state,
    //     emLeadsData: {
    //       ...state.emLeadsData,
    //       myLeads,
    //     },
    //   };
    // case _ownLead:
    //   var myLeads = {
    //     ...state.emLeadsData.myLeads.myLeads,
    //     [action.payload]: 1136,
    //   };
    //   var myLeads = {
    //     myLeads,
    //     myLeadsCount: state.emLeadsData.myLeads.myLeadsCount + 1,
    //   };
    //   console.log("Lead Print", myLeads);
    //   debugger;
    //   return {
    //     ...state,
    //     emLeadsData: {
    //       ...state.emLeadsData,
    //       myLeads,
    //     },
    //   };

    default:
      return state;
  }
}
